export default __webpack_public_path__ + "images/anexar-documentos-ico.svg";